import React from "react";

const Article = () => {
  return (
    <div>
      <div>
        <div id="introack" className="mb-20 mt-1">
          <p className="mb-10">
            For the past 3.5 mounths we have been working, day after day, on our
            beloved iGEM project. Along the way, we have recieved inpressive
            amount of support and help from various academics, university staff,
            friends and families, sponsors, patreons and unexpected good-doers.
            This page is a testimony of our gratitude, as we thank each and
            everyone of the people and institutions that helped us bring this
            project to life.
          </p>
          <h2 id="Sponsors">Sponsors </h2>
          <hr className="dividergeneral mb-5" />
          <div className="boxRem" style={{ width: "35rem" }}>
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/logomerck1.png"}
              alt="Merck Logo"
            />
            <details>
              <summary className="nameSponsor">Merck</summary>
              <h6 className="ml-1">Material Provider</h6>
              <p className="ml-1">
                Merck provided us with FLAG Purification Kit, FLAG
                ImmunoPrecipitation Kit and Cadmium Chloride which were very
                useful is concluding our project in the final weeks of our
                project.
              </p>
            </details>
          </div>

          <div className="boxRem" style={{ width: "22rem" }}>
            <img
              style={{ height: "auto" }}
              src={"https://static.igem.wiki/teams/4888/wiki/logoarhs.svg"}
              alt="Arhs Logo"
            />
            <details>
              <summary className="nameSponsor">Arηs</summary>
              <h6 className="ml-1">Financial Support</h6>
              <p className="ml-1">
                Thanks to the finacial support of Arηs our Team was able to
                travel to Munster and Zurich to collaborate with other iGEM
                teams.
              </p>
            </details>
          </div>

          <div className="boxRem" style={{ width: "18rem" }}>
            <img
              style={{ height: "auto" }}
              src={"https://static.igem.wiki/teams/4888/wiki/logopromega1.png"}
              alt="Pormega Logo"
            />
            <details>
              <summary className="nameSponsor">Promega</summary>
              <h6 className="ml-1">Material Provider</h6>
              <p className="ml-1">
                Protease Inhibitor Cocktail, Proteinase K (PK) Solution, ECL
                Western Blotting Substrate, MagneHis™ Protein Purification
                System
              </p>
            </details>
          </div>
          <div className="boxRem" style={{ width: "18rem" }}>
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/logobeckmanc.png"}
              alt="Beckman Logo"
            />
            <details>
              <summary className="nameSponsor">BeckmanCoulter</summary>
              <h6 className="ml-1">Material Provider</h6>
              <p className="ml-1">CosMCPrep Plasmid Purification kit</p>
            </details>
          </div>
          <div className="boxRem" style={{ width: "10rem" }}>
            <img
              src={"https://static.igem.wiki/teams/4888/wiki/logo-socorex.svg"}
              alt="Socorex Logo"
            />
            <details>
              <summary className="nameSponsor">Socorex</summary>
              <h6 className="ml-1">Financial Support</h6>
              <p className="ml-1">
                Thanks to the financial support of Socorex, we have been able to
                advance further in our project
              </p>
            </details>
          </div>
        </div>
        <div className="mb-20">
          <h2 id="Patreons">Patreons</h2>
          <hr className="dividergeneral mb-5" />

          <div className="boxRem" style={{ width: "25rem" }}>
            <img
              style={{ borderRadius: "25px" }}
              src={"https://static.igem.wiki/teams/4888/wiki/mistermario.jpg"}
              alt="MarioImage"
            />
            <details>
              <summary className="nameSponsor">Mario Mederos</summary>
              <i>
                "The road to a better world is believing in education and our
                youth. The EPFL is a renowned scientific institution, offering
                to its students reliable tools to enhance their intellectual
                capital. I am happy to be a Patron of the EPFL iGEM team. The
                project developed by those amazing students in combating the
                dangers of Cadmium presence in human’s body can benefit the
                lives of people, especially women during pregnancy, newly born,
                and children at early ages. Children’s health, and access to
                healthier food, free of heavy metals and chemicals, are one of
                my priorities to support. It is fantastic to see those students
                so motivated to learn and contribute to a better society.
                Through them, you can see how powerful education and investment
                in science are. I invite everyone to support education and the
                EPFL iGEM team to continue this amazing academic project. Those
                student’s work will most certainly generate a positive social
                impact on the lives of people worldwide"
              </i>
            </details>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article;
